module.exports = __webpack_public_path__ + "media/images/pic/lectors/anita-lawrynowicz-127236cda16bd70db5ec7f01754a0e5f.jpeg";